import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Users, Database, Settings as SettingsIcon, Activity, Layers, ArrowRight } from 'lucide-react';

const Admin = () => {
  const stats = [
    { label: 'Total Users', value: '0', icon: Users, color: '#3A7BFF' },
    { label: 'Total Organizations', value: '0', icon: Database, color: '#39E6C8' },
    { label: 'Active Subscriptions', value: '0', icon: Activity, color: '#29E07F' },
    { label: 'System Status', value: 'Online', icon: Shield, color: '#29E07F' },
  ];

  const adminModules = [
    {
      name: 'Content Sources',
      description: 'Manage uploads, lives, and replays',
      icon: Database,
      color: '#3A7BFF',
      path: '/admin/content-sources'
    },
    {
      name: 'Processed Assets',
      description: 'View all processed content outputs',
      icon: Layers,
      color: '#39E6C8',
      path: '/admin/processed-assets'
    }
  ];

  return (
    <div className="p-8 space-y-8" data-testid="admin-page">
      <div className="flex items-center gap-3">
        <Shield size={32} className="text-[#3A7BFF]" />
        <div>
          <h1 className="text-4xl font-bold text-white mb-2">Admin Panel</h1>
          <p className="text-[#8A93A6] text-lg">System administration and management.</p>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="glass rounded-2xl p-6">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                style={{ backgroundColor: `${stat.color}20` }}
              >
                <Icon size={24} style={{ color: stat.color }} />
              </div>
              <p className="text-2xl font-bold text-white mb-1">{stat.value}</p>
              <p className="text-[#8A93A6] text-sm">{stat.label}</p>
            </div>
          );
        })}
      </div>

      {/* Admin Modules */}
      <div className="glass rounded-2xl p-6">
        <h2 className="text-xl font-bold text-white mb-6">Admin Modules</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {adminModules.map((module) => {
            const Icon = module.icon;
            return (
              <Link
                key={module.path}
                to={module.path}
                data-testid={`admin-module-${module.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="glass rounded-xl p-6 hover:border-[#3A7BFF]/50 border border-white/10 transition-all group"
              >
                <div className="flex items-start justify-between mb-4">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${module.color}20` }}
                  >
                    <Icon size={24} style={{ color: module.color }} />
                  </div>
                  <ArrowRight size={20} className="text-[#8A93A6] group-hover:text-[#3A7BFF] transition-colors" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{module.name}</h3>
                <p className="text-sm text-[#8A93A6]">{module.description}</p>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Management Sections */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="glass rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-6">
            <Users size={24} className="text-[#3A7BFF]" />
            <h2 className="text-xl font-bold text-white">User Management</h2>
          </div>
          <div className="h-64 flex items-center justify-center border-2 border-dashed border-white/10 rounded-xl">
            <p className="text-[#8A93A6]">User management will appear here</p>
          </div>
        </div>

        <div className="glass rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-6">
            <SettingsIcon size={24} className="text-[#39E6C8]" />
            <h2 className="text-xl font-bold text-white">System Settings</h2>
          </div>
          <div className="h-64 flex items-center justify-center border-2 border-dashed border-white/10 rounded-xl">
            <p className="text-[#8A93A6]">System settings will appear here</p>
          </div>
        </div>
      </div>

      {/* Activity Log */}
      <div className="glass rounded-2xl p-6">
        <h2 className="text-xl font-bold text-white mb-6">Activity Log</h2>
        <div className="h-64 flex items-center justify-center border-2 border-dashed border-white/10 rounded-xl">
          <p className="text-[#8A93A6]">Activity log will appear here</p>
        </div>
      </div>
    </div>
  );
};

export default Admin;
